<template>
    <div>
        <header-message>Centerline Setup</header-message>
        <div class="container-fluid">
            <div class="row mt-4">
                <div class="text-center">
                    <img src="/img/Centerline.png" class="img-fluid centerline" alt="Centerline Setup">
                </div>
            </div>
            <header-message class="mt-3">
                Placeholder Text Here
            </header-message>
        </div>
        <div class="buttonrow">
            <button-button type="button" class="btn btn-secondary me-4" @click.prevent="cancelClicked" :disabled="loading">Cancel</button-button>
            <spin-button class="btn-primary" type="submit" @click.prevent="nextClicked" :spinning="loading" :disabled="loading">Next</spin-button>
        </div>
    </div>
</template>

<style scoped lang="scss">
    img.centerline {
        max-height: 45vh;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import { ButtonClicked } from "@/shared/enums/ButtonClicked";
import { confirmYesNo } from "@/shared/components/common/AlertDialog.vue";
import { Global } from "@/support/GlobalData";
import { SignalR } from "@/support/SignalR";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { CalibrationEvent } from "@/shared/enums/CalibrationEvent";
import { DeviceStatusDto } from "@/shared/models/DeviceStatusDto";

export default defineComponent({
    name: "CalibrationCenterlineInstruction",
    mixins: [PageBase],
    components: {
        HeaderMessage,
    },
    data() {
        return {
            nextTimeout: 0,
        };
    },
    methods: {
        nextClicked(): void {
            this.$router.push("/Calibration/CameraReady");
        },
        cancelClicked(): void {
            confirmYesNo("Are you sure you want to cancel this calibration?")
                .then((clicked: ButtonClicked): void => {
                    if (clicked === ButtonClicked.Ok) {
                        CalibrationEventSupport.sendEvent(CalibrationEvent.CalibrationCustomerCanceled);
                        Global.MainApp.clearSession();
                        this.$router.push("/");
                    }
                });
        },
        getCurrentStatusForListeners(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationCenterlineInstruction",
            } as DeviceStatusDto);
        }
    },
    mounted(): void {
        // When centerline is disabled for the unit, or unsupported by the client, the step is bypassed entirely.
        if (!Global.CalibrationSession || !Global.CenterlineEnabledInd || !Global.IsCenterlineSupported()) {
            this.$router.push("/Calibration/CameraReady");
            return;
        }
        SignalR.onGetCurrentStatusForListeners = this.getCurrentStatusForListeners;
        if (Global.IsTechControlled) {
            SignalR.onGetCameraAlignmentImage = (): void => { /*ignore*/ };
            this.nextTimeout = setTimeout((): void => {
                this.nextTimeout = 0;
                this.nextClicked();
            }, 5000) as unknown as number;
        } else {
            // A companion-controlled session advances this instruction step from the Companion's Next button.
            SignalR.onGetCameraAlignmentImage = this.nextClicked;
        }
        this.getCurrentStatusForListeners();
    },
    unmounted(): void {
        SignalR.onGetCurrentStatusForListeners = null;
        SignalR.onGetCameraAlignmentImage = null;
        if (this.nextTimeout) {
            clearTimeout(this.nextTimeout);
            this.nextTimeout = 0;
        }
    }
});
</script>
